module.exports = __webpack_public_path__ + "img/seat.41864646.png";